<template>
  <div class="select-card">
    <div v-if="!loading" class="select-card__content">
      <!-- Saved Cards -->
      <div class="select-card__list">
        <button
          v-for="(card, index) in entityCard"
          :key="index"
          class="select-card__item"
          @click="fundWithStoredCard(card.token)"
        >
          <div class="select-card__card-icon">
            <img
              v-if="card.type === 'MASTERCARD'"
              src="@/assets/img/mastercard.svg"
              alt="mastercard"
            />
            <img
              v-else-if="card.type === 'VISA'"
              src="@/assets/img/visa.svg"
              alt="visa"
            />
            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
              <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.5"/>
              <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </div>
          <div class="select-card__card-info">
            <span class="select-card__card-number">**** **** **** {{ card.last_four }}</span>
            <span class="select-card__card-expiry">Expires {{ card.expiry }}</span>
          </div>
          <svg class="select-card__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Remember Card Toggle -->
      <div class="select-card__toggle">
        <div class="select-card__toggle-content">
          <h4>Remember my new card details</h4>
          <p>You won't have to add it again</p>
        </div>
        <ToggleButton @valueSelected="toggleMode" />
      </div>

      <!-- New Card Option -->
      <button class="select-card__new-card" @click="flutterwaveFunding">
        <div class="select-card__icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10 7V13M7 10H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="select-card__new-card-content">
          <h4>Use a New Card</h4>
          <p>You will be redirected to {{ capitalize(provider) }} to enter your card details</p>
        </div>
        <svg class="select-card__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- Security Notice -->
      <p class="select-card__notice">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M7 1L12 3V6.5C12 9.5 10 11.5 7 13C4 11.5 2 9.5 2 6.5V3L7 1Z" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"/>
          <path d="M5 7L6.5 8.5L9 5.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Transactions secured by {{ capitalize(provider) }}
      </p>
    </div>
    <SmallLoader v-if="loading" />
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import ToggleButton from "@/components/general/ToggleButton";
  import responseHandler from "@/utils/responseHandler.js";
  import api from "@/utils/api.js";
  import { getItem } from "@/utils/storage.js";
  import { capitalize } from "@/utils/helpers";
  // import { useFundingProvider } from "@/composables/fundingProvider";

  export default {
    name: "SelectDebitCardForm",

    components: {
      ToggleButton,
    },

    props: {
      fundOptions: { type: String, default: () => "", required: true },
    },

    data() {
      return {
        user: getItem("org_details"),
        fundPayload: getItem("fundPayload"),
        addCard: false,
        loading: false,
      };
    },
    inject: ["provider"],

    computed: {
      ...mapState({
        currency: (state) => state.organisationModule.currency,
        entityCard: (state) => state.organisationModule.entityCard,
      }),
    },

    mounted() {
      this.getEntityCard();
      this.fundPayload = getItem("fundPayload");
    },

    methods: {
      capitalize,
      ...mapActions("organisationModule", ["getEntityCard"]),
      // async fundRequest() {
      //   switch (this.fundOptions) {
      //     case "new card":
      //       this.flutterwaveFunding();
      //       break;
      //     case "stored card":
      //       this.fundWithStoredCard();
      //       break;

      //     default:
      //       break;
      //   }
      // },

      async flutterwaveFunding() {
        this.loading = true;
        const data = {
          amount: this.fundPayload.amount,
          currency: this.currency,
          customer: {
            name: `${this.user.name}`,
            email: this.user.email,
          },

          customizations: this.customizations,
          meta: {
            tokens: Number(this.fundPayload.tokens),
            entity: "user",
            add_card: this.addCard,
          },

          paymentReference: "",
          redirect_url: window.location.origin + window.location.pathname,

          payment_options: ["card"],
        };
        try {
          const response = await api.fundWithProvider({
            data,
            type: this.provider,
          });
          window.location =
            this.provider === "flutterwave"
              ? response.data.data.link
              : response.data.data.url;
          this.loading = false;
        } catch (error) {
          this.loading = false;
          responseHandler.handleError(error);
        }
      },

      async fundWithStoredCard(token) {
        this.loading = true;
        const data = {
          amount: this.fundPayload.amount,
          currency: this.currency,
          token,
          customer: {
            name: `${this.user.fname} ${this.user.lname}`,
            email: this.user.email,
          },

          customizations: this.customizations,
          meta: {
            tokens: Number(this.fundPayload.tokens),
            entity: "user",
          },

          paymentReference: "",
          redirect_url: window.location.origin + window.location.pathname,

          payment_options: ["card"],
        };
        try {
          const response = await api.fundWithProvider({
            data,
            type: this.provider,
          });
          window.location = response.data.data.link;
          this.loading = false;
        } catch (error) {
          responseHandler.handleError(error);
          this.loading = false;
        }
      },

      toggleMode(val) {
        this.addCard = val;
      },
    },
  };
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-card: #FFFFFF;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$accent-primary: #6366F1;
$accent-light: #EEF2FF;

.select-card {
  padding: 8px 0;

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:hover {
      background: $bg-subtle;
      margin: 0 -16px;
      padding: 16px;
      width: calc(100% + 32px);
      border-radius: 10px;
      border-bottom-color: transparent;
    }
  }

  &__card-icon {
    width: 48px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__card-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__card-number {
    font-size: 14px;
    font-weight: 600;
    color: $text-primary;
  }

  &__card-expiry {
    font-size: 13px;
    color: $text-muted;
  }

  &__toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: $bg-subtle;
    border-radius: 10px;
    margin: 16px 0;
  }

  &__toggle-content {
    h4 {
      font-size: 14px;
      font-weight: 500;
      color: $text-primary;
      margin: 0 0 2px;
    }

    p {
      font-size: 13px;
      color: $text-muted;
      margin: 0;
    }
  }

  &__new-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:hover {
      background: $bg-subtle;
      margin: 0 -16px;
      padding: 16px;
      width: calc(100% + 32px);
      border-radius: 10px;
      border-bottom-color: transparent;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $accent-light;
    border-radius: 10px;
    color: $accent-primary;
    flex-shrink: 0;
  }

  &__new-card-content {
    flex: 1;

    h4 {
      font-size: 14px;
      font-weight: 600;
      color: $text-primary;
      margin: 0 0 4px;
    }

    p {
      font-size: 13px;
      color: $text-muted;
      margin: 0;
      line-height: 1.4;
    }
  }

  &__arrow {
    color: $text-muted;
    flex-shrink: 0;
    margin-top: 4px;
    transition: transform 0.2s ease;
  }

  &__item:hover &__arrow,
  &__new-card:hover &__arrow {
    transform: translateX(2px);
  }

  &__notice {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
    color: $text-muted;
    margin: 24px 0 0;

    svg {
      color: $accent-primary;
    }
  }
}
</style>